export interface UseNavigationOptions {
  onNavigate?: (target: string) => void;
}

/**
 * Minimal navigation helper used door AI Assistant.
 * Stuurt naar hash-routes of roept een meegegeven callback aan.
 */
export const useNavigation = ({ onNavigate }: UseNavigationOptions = {}) => {
  const navigate = (target: string) => {
    if (onNavigate) {
      onNavigate(target);
      return;
    }
    if (typeof window !== 'undefined') {
      window.location.hash = target;
    }
  };

  return { navigate };
};
